import { Component, OnInit } from '@angular/core';
import { error } from 'console';
import { data } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, delay, filter, findIndex, map, takeUntil, tap } from 'rxjs/operators';
import { ReportService } from 'src/app/service/report.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import moment from 'moment';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { ReportUser } from 'src/app/models/user';

@Component({
  selector: 'app-pheme-reports',
  templateUrl: './pheme-reports.component.html',
  styleUrls: ['./pheme-reports.component.css']
})
export class PhemeReportsComponent implements OnInit {

   phemeReport:any;
   userId="";
   selectedReport="";
   exportType="";
   documentType="";
   filter:any;
   filterValue:any[]=[];
   filterData:any;
   ansCount=0;
   Object = Object;
   statusCode="";
   public users!: any[];
   
  constructor(public router: Router,private report:ReportService,private spinner: NgxSpinnerService,private sideNav : SideNavServiceService, private reportService:ReportService) { 
   this.getAllReports();
   this.loadUsers();
  }

  filterCondition(event:any){
    this.ansCount=0;
    this.selectedReport=event.value;
    if(this.filterValue.length!=0)
    this.filterValue=[];
 
    this.spinner.show();
     this.phemeReport.forEach((element:any) => {
      element.AdhocReport.forEach((elem:any)=>{
        if(elem.templateCode==this.selectedReport){
          this.exportType=elem.exportType;
        }
      })
     });

    var reportData={
      templateCode:this.selectedReport,
      loginName : localStorage.getItem("loginName"),
      loginKey : localStorage.getItem('loginKey'),
    }
   this.report.getFilter(reportData).subscribe(data=>{
    this.filter=data.body.filterCondition;
    this.spinner.hide();
   },error=>{
    this.spinner.hide();
    alert(error);
    this.router.navigate(['dashboard']);  
 
   })
  }
  getAllReports(){
    this.spinner.show();
    var param="DS_AgoraReports_1"
    var userData={
      loginName : localStorage.getItem("loginName"),
      loginKey : localStorage.getItem('loginKey'),
      source : "DS_AgoraReports_1",
     }
    this.report.getAllReports(userData).subscribe(data=>{
 
      this.phemeReport=data.body.templateList;
      this.spinner.hide();
    },error=>{
      this.spinner.hide();
      this.sideNav.alertPhemeError("User does not have application rights");
      this.router.navigate(['dashboard']); 
    })
  }

  check(event:any,type:any,index:any){
    this.ansCount=0;
    if(event.value||event.innerHTML){
    if(type=='DATE'||type=='TIMESTAMP'){
       this.filterValue[index] = "trunc(to_date('"+event.value+"','mm/dd/yyyy HH24:MI:SS'))";
    }
    else if(type.includes('VARCHAR')){
    this.filterValue[index] = "'"+event.value+"'";
    }
    else if(type=='NUMBER'){
      this.filterValue[index] = event.value
    }
    else if(type=='dropdown'){
      this.filterValue[index] = event.value;
    }
 
    this.filterValue.forEach((data:any)=>{
      if(data!=null||data!=undefined||data!=""){
        ++this.ansCount;
      }
   })
  }
   }
  export(){
 
    if(this.filter!=undefined){
    var filterLength=this.filter.length;
    this.filter.forEach((data:any)=>{
          if(data.isValueQueryFlag=='true'){
            filterLength--;
          }
    })
    if(filterLength!=0&&this.documentType!=""){
    if(filterLength==this.ansCount){
      var condition="";
    this.filterValue.forEach((data:any)=>{
      if(data!=null||data!=undefined||data!="")
       condition+=data+"~";
    })
    condition=condition.substring(0,condition.length-1);
      this.spinner.show();
      var userData={
        loginName : localStorage.getItem("loginName"),
        loginKey : localStorage.getItem('loginKey'),
        exportType:this.documentType,
        templateCode:this.selectedReport,
        filterCondition:condition
      }
      this.report.exportReport(userData).subscribe(data=>{
        this.spinner.hide();
        if(data.body.Status.statusCode=='SUCCESS'){
          window.open(data.body.downloadPath);
        this.sideNav.alertPhemeSuccess("Report Exported Successfully")
        }
        else{
          this.sideNav.alertPhemeError("No data found");
        }
      },error=>{
        this.spinner.hide();
        alert("error: " +error)
        this.router.navigate(['dashboard']);
      })
    }
    else{
      this.sideNav.alertPhemeError("Please fill filter conditions");
    }
  }
  else{
    if(this.selectedReport!=""&&this.documentType!=""){
      this.spinner.show();
    var userDatas={
      loginName : localStorage.getItem("loginName"),
      loginKey : localStorage.getItem('loginKey'),
      exportType:this.documentType,
      templateCode:this.selectedReport
    }
    this.report.exportReport(userDatas).subscribe(data=>{
      this.spinner.hide();
      if(data.body.Status.statusCode=='SUCCESS'){
      window.open(data.body.downloadPath);
      this.sideNav.alertPhemeSuccess("Report Exported Successfully")
      }
      else{
        this.sideNav.alertPhemeError("No data found");
      }
    },error=>{
      this.spinner.hide();
      alert("error: " +error)
      this.router.navigate(['dashboard']);
    })
    }
    else{
      this.sideNav.alertPhemeError("Please Choose Export Type"); 
    }
  }
}
else{
  this.sideNav.alertPhemeError("Please Choose Report"); 
}
    
  }

  loadUsers(){
    return new Promise(async (resolve, reject) => {
      await this.reportService.loadUsers().subscribe(userList => {
        if (userList!= null && userList != undefined) {
           this.users = userList;
           
          resolve(this.users);
        }
      });
     
    });
}

  ngOnInit(): void {
  
  } 
  
}
